import { Reveal } from "./Reveal";

// ---------------------------------------------------------------------------
// WHO DOES WHAT — "Tu parte entra en un post-it." Vos vs Nosotros.
// ---------------------------------------------------------------------------

const youDo = [
  { n: "01", t: "Decirnos cuánto salió el presupuesto" },
  { n: "02", t: "Marcar si lo ganaste o lo perdiste" },
  { n: "03", t: "Cerrar la venta cuando te deriva el Agente" },
];

const weDo = [
  "Armamos tu web y tu ficha de Google",
  "Configuramos el inbox de todos los canales",
  "Entrenamos al Agente IA con tu tono",
  "Hacemos el seguimiento de cada presupuesto",
  "Pedimos las reseñas después de cada trabajo",
  "Reactivamos a tus clientes anteriores",
  "Mandamos el reporte todos los lunes",
  "Te damos soporte por WhatsApp con gente real",
];

export function HomeWhoDoesWhat() {
  return (
    <section
      data-screen-label="Quién hace qué"
      className="mx-auto px-6"
      style={{
        maxWidth: 1240,
        paddingTop: 0,
        paddingBottom: "clamp(80px,10vw,128px)",
      }}
    >
      <Reveal>
        <div
          className="font-mono text-[13px] text-[#A78BFA]"
          style={{ letterSpacing: "0.08em" }}
        >
          05 — QUIÉN HACE QUÉ
        </div>
        <h2
          className="mt-5 text-[#EEEDF2] font-medium"
          style={{
            fontSize: "clamp(36px,4.8vw,64px)",
            lineHeight: 1.02,
            letterSpacing: "-0.03em",
            maxWidth: 820,
            textWrap: "balance" as never,
          }}
        >
          Tu parte entra en un post-it.
        </h2>
      </Reveal>

      <div
        className="grid gap-4 mt-12"
        style={{
          gridTemplateColumns: "repeat(auto-fit,minmax(min(100%,340px),1fr))",
        }}
      >
        <Reveal delay={0.05}>
          <div className="border border-[#2A2633] rounded-[18px] p-8 bg-[#13111A] h-full">
            <div className="flex justify-between items-baseline">
              <span className="text-[22px] font-semibold text-[#EEEDF2]">
                Vos
              </span>
              <span className="font-mono text-[12px] text-[#9C98A6]">
                {youDo.length} COSAS
              </span>
            </div>
            <div className="flex flex-col mt-5">
              {youDo.map((x) => (
                <div
                  key={x.n}
                  className="grid py-3.5 border-t border-[#221F2A] leading-[1.45] text-[#EEEDF2]"
                  style={{ gridTemplateColumns: "28px 1fr", gap: 8 }}
                >
                  <span className="font-mono text-[12px] text-[#6E6A7A] pt-0.5">
                    {x.n}
                  </span>
                  <span>{x.t}</span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div
            className="rounded-[18px] p-8 h-full"
            style={{
              border: "1px solid #4C3A7A",
              background:
                "linear-gradient(180deg,rgba(124,58,237,0.14),rgba(124,58,237,0.03))",
            }}
          >
            <div className="flex justify-between items-baseline">
              <span className="text-[22px] font-semibold text-[#EEEDF2]">
                Nosotros
              </span>
              <span className="font-mono text-[12px] text-[#A78BFA]">
                TODO LO DEMÁS
              </span>
            </div>
            <div className="flex flex-col mt-5">
              {weDo.map((x) => (
                <div
                  key={x}
                  className="grid py-3.5 border-t leading-[1.45] text-[#EEEDF2]"
                  style={{
                    gridTemplateColumns: "28px 1fr",
                    gap: 8,
                    borderColor: "#2A2340",
                  }}
                >
                  <span className="text-[#A78BFA]">✓</span>
                  <span>{x}</span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
